// export const DRAW_REWARDS = [
//   {
//     amount: 999,
//     chance: 0.00002,
//   },
//   {
//     amount: 499,
//     chance: 0.000035,
//   },
//   {
//     amount: 199,
//     chance: 0.000045,
//   },
//   {
//     amount: 99,
//     chance: 0.000065,
//   },
//   {
//     amount: 60,
//     chance: 0.00009,
//   },
//   {
//     amount: 2.07,
//     chance: 0.095,
//   },
//   {
//     amount: 1.8,
//     chance: 0.09,
//   },
//   {
//     amount: 0.26,
//     chance: 0.115175,
//   },
//   {
//     amount: 0.11,
//     chance: 0.199915,
//   },
//   {
//     amount: 0.02,
//     chance: 0.199675,
//   },
//   {
//     amount: 0.01,
//     chance: 0.29998,
//   },
// ];

export const MOON_DRAW_AMOUNT = 0.52;

export const MOON_DRAW_UPDATE_BALACE_DELAY_MS = 4500;
export const MOON_DRAW_UPDATE_BALACE_DELAY_MS_SHORT = 500;
